import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { CleanKennelAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-clean-kennel-slot',
    templateUrl: './clean-kennel-slot.component.html',
    styleUrl: './clean-kennel-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CleanKennelSlotComponent implements SheetSlotComponentBase {

	@Input() action!: CleanKennelAction;
	value = null;

	constructor() {
	}
}